import { render, staticRenderFns } from "./BillingAccountForm.vue?vue&type=template&id=18145a6e&"
import script from "./BillingAccountForm.vue?vue&type=script&lang=ts&"
export * from "./BillingAccountForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports